import { render, staticRenderFns } from "./SettingsTabGlobalConfig.vue?vue&type=template&id=007646fa&scoped=true"
import script from "./SettingsTabGlobalConfig.vue?vue&type=script&lang=ts"
export * from "./SettingsTabGlobalConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007646fa",
  null
  
)

export default component.exports